import { storage } from './storage.js';
import { isHotelId, isConversion } from './guards.js';
export function setConversionData(hotelId, conversion) {
    if (!isHotelId(hotelId)) {
        throw new Error('setConversionData was called with invalid "id".');
    }
    if (!isConversion(conversion)) {
        throw new Error('setConversionData was called with invalid "conversion".');
    }
    storage.setById(hotelId, (prev) => ({
        ts: Date.now(),
        conversions: {
            ...prev?.conversions,
            [conversion.type]: conversion,
        },
        journeys: [],
    }));
}
//# sourceMappingURL=setConversionData.js.map